import { DailyRateService } from './../../service/daily-rate.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, Injector, OnInit } from '@angular/core';
import { CommonDataService } from 'src/app/core/services/common-data.service';

@Component({
  selector: 'laas-daily-rate-setting-detail',
  templateUrl: './daily-rate-setting-detail.component.html',
  styleUrls: ['./daily-rate-setting-detail.component.scss']
})
export class DailyRateSettingDetailComponent extends SessionBaseComponent implements OnInit {

  dailyRate: any;
  rateTypeOptions: any[];
  isActivatedOptions: any[];
  currencyOptions: any[];
  isShowEditBtn: boolean;
  isShowCancelBtn: boolean;

  constructor(
    injector: Injector,
    private dailyRateService: DailyRateService,
    private facilityService: FacilityService,
    private commonDataService: CommonDataService,
  ) {
    super(injector);
    this.dailyRate = {};
    this.rateTypeOptions = [];
    this.currencyOptions = [];
    this.isActivatedOptions = [];
    this.isShowEditBtn = false;
    this.isShowCancelBtn = false;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    this.isActivatedOptions = [
      { label: 'Y', value: '1' },
      { label: 'N', value: '0' }
    ];

    const seqNo = this.routeStateService.getCurrent().data.seqNo;

    try {
      this.dailyRate = await this.dailyRateService.getDailyRateDetail(seqNo);
    } catch (err: any) {
      console.log('get daily rate occur error: ' + JSON.stringify(err));
    }

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'RateType').subscribe({
      next: result => {
        this.rateTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
        this.currencyOptions.unshift({
          label: "請選擇",
          value: ""
        });
      }
    });

    this.isShowEditBtn = true;
    this.isShowCancelBtn = true;
  }

  goToEdit(event: any): void {
    this.routeStateService.navigateTo('/Setting/DailyRateSettingEdit', this.dailyRate);
  }

  goToSearchPage(envet: any): void {
    this.routeStateService.navigateTo('/Setting/DailyRateSetting');
  }

}
